import { render, staticRenderFns } from "./shop-product-bonus.vue?vue&type=template&id=78800276&scoped=true&"
import script from "./shop-product-bonus.vue?vue&type=script&lang=js&"
export * from "./shop-product-bonus.vue?vue&type=script&lang=js&"
import style0 from "./shop-product-bonus.vue?vue&type=style&index=0&id=78800276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78800276",
  null
  
)

export default component.exports